var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('v-snackbar',{model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[_vm._v("\n        "+_vm._s(_vm.snackbarMessage)+"\n        "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.showSnackbar=false}}},[_vm._v("OK")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }